import type { CSSProperties } from 'react';
import type { Book } from '@booknest/shared';

import { SafeCoverImg } from '@/shared/components/SafeCoverImg.js';

import { pickColors, pickTextureBase } from './spine-utils.js';

interface BookCoverOnShelfProps {
  book: Book;
  opening?: boolean;
  onClick?: () => void;
}

/**
 * Livre posé face avant. Hauteur calée sur `--spine-max-h` (ce qui ajuste
 * automatiquement la cover quand on passe en mode compact). Ratio cover 2/3.
 */
export function BookCoverOnShelf({
  book,
  opening = false,
  onClick,
}: BookCoverOnShelfProps): JSX.Element {
  const [c1, c2] = pickColors(book);
  const textureBase = pickTextureBase(book);
  const cssVars: CSSProperties = {
    width: 'calc(var(--spine-max-h) * 0.62)',
    height: 'calc(var(--spine-max-h) * 0.93)',
    ['--c1' as string]: c1,
    ['--c2' as string]: c2,
    background: `linear-gradient(135deg, ${c1}, ${c2})`,
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${book.title} — ${book.author}`}
      className={`book-cover-on-shelf${opening ? ' opening' : ''}`}
      style={cssVars}
    >
      <SafeCoverImg
        url={book.coverUrl}
        className="h-full w-full object-cover"
        fallback={
          <div
            className={`${textureBase} flex h-full w-full items-center justify-center px-1.5 py-2`}
          >
            <p
              className="line-clamp-4 text-center font-serif text-[10px] font-bold leading-tight"
              style={{
                color: 'rgba(255, 220, 150, 0.95)',
                textShadow:
                  '0 0 4px rgba(218,165,32,0.65), 0 1px 2px rgba(0,0,0,0.5)',
              }}
            >
              {book.title}
            </p>
          </div>
        }
      />
    </button>
  );
}
